import React from "react";
import Stage3SyncPanel from "../stage3/Stage3SyncPanel";

const STAGE3_REAL = process.env.REACT_APP_STAGE3_REAL === "true";

export default function Six_Players_Stage3_Player4(props) {
  return STAGE3_REAL ? <RealStage3_Player4 {...props} /> : <PlaceholderStage3_Player4 {...props} />;
}

function PlaceholderStage3_Player4() {
  return (
    <div>
      <h2>🧪 Étape 3 — Joueur 4 - Version Bêta (placeholder)</h2>

      <p className="mt-2">
        Cette page est <strong>temporaire</strong> pour la bêta : l’énigme de l’étape 3 arrive bientôt.
        <br />
        Ici, on teste surtout que chaque joueur reçoit la <strong>bonne page</strong> et que la suite se synchronise.
      </p>

      <div className="mt-4 p-3 rounded bg-slate-900">
        <p className="font-semibold">✅ Ce que tu peux faire maintenant</p>
        <ul className="list-disc ml-5 mt-2">
          <li>Confirme à l’équipe que tu vois bien “Étape 3”</li>
          <li>Attends que le joueur responsable fasse avancer l’étape</li>
          <li>Vérifie que ton écran bascule bien vers la page des scores</li>
        </ul>
      </div>

      <p className="mt-4 text-sm text-slate-500">
        Si tu restes bloqué(e) : rafraîchis la page (F5). Si ça persiste, préviens l’organisateur.
      </p>
    </div>
  );
}

function RealStage3_Player4(props) {
  const { onSuccessCutsceneStart, onSuccessCutsceneEnd, onNavigateToScoreboard, centerMaxH, code, playerId, pageVariant, playerCount, pseudo, canAdvance, isCanAdvance, hintSignal, raisedCount, raisedPlayers } = props;
  return (
    <Stage3SyncPanel
      centerMaxH={centerMaxH}
      canAdvance={canAdvance}
      isCanAdvance={isCanAdvance}
      code={code}
      pseudo={pseudo}
      playerId={playerId}
      myVariant={pageVariant}
      playerCount={playerCount}
      raisedCount={raisedCount}
      raisedPlayers={raisedPlayers}
      hintSignal={hintSignal}
      onSuccessCutsceneStart={onSuccessCutsceneStart}
      onSuccessCutsceneEnd={onSuccessCutsceneEnd}
      onNavigateToScoreboard={onNavigateToScoreboard}
      onAllReady={() => {
      }}
    />
  );
}